import { render } from "./FlangeIntegralCalculatorComponent.vue?vue&type=template&id=076770ca"
import script from "./FlangeIntegralCalculatorComponent.vue?vue&type=script&lang=js"
export * from "./FlangeIntegralCalculatorComponent.vue?vue&type=script&lang=js"

import "./FlangeIntegralCalculatorComponent.vue?vue&type=style&index=0&id=076770ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__